'use client'

import Link from 'next/link'
import { useDomain } from '@/hooks/useDomain'

export default function NotFound() {
  const { city } = useDomain()

  return (
    <div className="min-h-screen bg-blue-50 flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-blue-800 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-4">The page you&apos;re looking for doesn&apos;t exist.</p>
        <Link 
          href="/" 
          className="text-blue-600 hover:text-blue-800 underline"
        >
          Return to {city} Orthopedic Home
        </Link>
      </div>
    </div>
  )
} 